import { type EatingPreferencesAction, EatingPreferencesActionTypes, type EatingPreferencesState } from './types'

export const initialEatingPreferencesState: EatingPreferencesState = {
  preferences: null,
  loading: true,
  error: null
}

export function eatingPreferencesReducer(state: EatingPreferencesState, action: EatingPreferencesAction): EatingPreferencesState {
  switch (action.type) {
    case EatingPreferencesActionTypes.SET_PREFERENCES:
      return { ...state, preferences: action.payload, loading: false, error: null }
    case EatingPreferencesActionTypes.SET_ERROR:
      return { ...state, loading: false, error: action.payload }
    case EatingPreferencesActionTypes.CLEAR:
      return { ...initialEatingPreferencesState }
    default:
      return state
  }
}
